import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import ActionHome from 'material-ui/svg-icons/action/home';
import _ from 'lodash';
import selfPayComsumablestore from '../store/SelfPayComsumablestore';
import { observer } from 'mobx-react'
import {Card,CardHeader, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';
import { withRouter } from 'react-router' 
import ResultDialog from './ResultDialog';
import Loading from './Loading';

class Result extends Component {
    constructor(props){
        super(props)
        this.goback = this.goback.bind(this);
        this.home = this.home.bind(this)
        
    } 
    componentWillMount(){
        const queryString = require('query-string');
        let parsed = queryString.parse(this.props.location.search);

        //補上未出現在GET參數的querydata
        // if(_.size(parsed) < _.size(selfPayComsumablestore.querydata)){
            
            
        //     _.map(parsed, (item, key)=>{
        //         if(item.length>0){
        //             selfPayComsumablestore.querydata[key] = parsed[key];
        //         }                               
        //     })
        //     parsed = Object.assign({}, selfPayComsumablestore.querydata);                 
        // }

       
        

        selfPayComsumablestore.setLoaddata(parsed)        
        
    }
 

    componentWillUnmount(){
        selfPayComsumablestore.resetData()
    } 

   

    
    home(){
        window.location.href = /m/        
    }
    
    
    goback(){
        selfPayComsumablestore.resetData()       
        // this.props.history.goBack()
        this.props.history.push('/')
    }
    
    render() {  
        
        
        let strUrl = window.location.search;
       
        
        let getPara, ParaVal;
        let aryPara = [];

        if (strUrl.indexOf("?") !== -1) {
        let getSearch = strUrl.split("?");
        getPara = getSearch[1].split("&");
        for (let i = 0; i < getPara.length; i++) {
            ParaVal = getPara[i].split("=");
            aryPara.push(ParaVal[0]);
            aryPara[ParaVal[0]] = ParaVal[1];
        }
        }
        

        if(selfPayComsumablestore.allowShowData){   
      return (
        <div className="SelfPayComsumableResult" style={{paddingBottom: "10px", minHeight:"98.5vh", overflow:"auto"}}>
         {
              aryPara.app === 'true' ? null :
         <AppBar 
            title={<div>自費醫材查詢結果<span style={{ fontSize: '11px' }}>{}</span></div>}
            style={{ backgroundColor: 'white', textAlign: 'center', height: '44px' }}
            titleStyle={{ color: 'black', height: '44px', fontWeight: '500', fontSize: '17px', lineHeight: '44px', weight: '46%', textAlign: 'center' }}
            iconElementLeft={<ChevronLeft onClick={this.goback} />}
            iconStyleLeft={{"cursor": "pointer"}}             
            iconElementRight={<ActionHome onClick={this.home} />}
            iconStyleRight={{"cursor": "pointer"}}
         />  }  
            <div className="SelfPayComsumableQuery_content" style={{"padding": "20px 15px 0px 15px"}}>
            <Card style={{marginBottom: "20px"}}>
                <CardHeader
                title="查詢條件"
                style={{paddingBottom: "0px"}}
                />
                <CardText
                style={{display: "flex", flexWrap: "wrap"}}
                >                
                    {_.map(selfPayComsumablestore.queryfactors,(item, key)=>{
                                                                    
                    return (
                    <Chip
                    key={key}
                    labelStyle={{fontSize:"10px"}} 
                    labelColor="rgb(33, 150, 243)"
                    style={{margin: "3px"}}                   
                    >
                    {key} : {item}
                    </Chip>)
                    })}                    
                </CardText>
            </Card>
            {_.map(selfPayComsumablestore.resultData, (o, key)=>{       
                                         
                      return(<ResultDialog       
                      isOpen={o.open} 
                      key={key} 
                      ordernum ={o.order_num}                   
                      alldata={o}              
                      />)                   
            })}            
           
            </div>      
        </div>
        
    );
    }
    else{              
        return <Loading />
    }    
  }
}

export default withRouter(observer(Result));



// WEBPACK FOOTER //
// ./src/components/layout/Result.js